export default __webpack_public_path__ + "static/media/05_photo.78187416.jpg";